import { HttpEvent, HttpHandlerFn, HttpHeaders, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

declare const MiniProfiler: any;

export const miniProfilerInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  return next(req).pipe(tap(evt => {
    if (evt instanceof HttpResponse) {
      if (typeof MiniProfiler !== 'undefined' && evt && evt.headers) {
        makeMiniProfilerRequests(evt.headers);
      }
    }
  }));
};

const makeMiniProfilerRequests = (headers: HttpHeaders) => {
  const miniProfilerHeaders = headers.getAll('x-miniprofiler-ids');

  if (!miniProfilerHeaders) {
    return;
  }

  miniProfilerHeaders.forEach(miniProfilerIdHeaderValue => {
    const ids = JSON.parse(miniProfilerIdHeaderValue) as Array<string>;
    MiniProfiler.fetchResults(ids);
  });
};
